import { computed, ref, Ref } from 'vue'

export type ShiftAssignmentDialogState = {
    visible: boolean
}

const state: Ref<ShiftAssignmentDialogState> = ref({
    visible: false,
})

export function useShiftAssignmentDialog() {
    const show = () => {
        state.value = {
            visible: true,
        }
    }

    const hide = () => {
        state.value = {
            visible: false,
        }
    }

    const isShown = computed(() => state.value.visible)

    return {
        show,
        hide,
        isShown,
    }
}